<template>
  <div class="UnitManage">
    <van-nav-bar
          left-arrow
          fixed
          @click-left="goback"
          :title="
            status == 0
              ? $t('itemInfo.exWarehouse')
              : $t('itemInfo.warehousing')
          "
    />
    <!-- 表單模塊 -->
    <div class="shopList ninew bodybox">
      <!-- 物品名称 -->
      <van-cell-group>
        <van-field
          v-model="itemInfo.name"
          :label="$t('itemInfo.name')"
          readonly
          :placeholder="$t('itemInfo.inputName')"
        />
      </van-cell-group>
      <!-- 物品数量 -->
      <van-cell-group>
        <van-field
          v-model="itemInfo.number"
          type="digit"
          :label="$t('itemInfo.number')"
          clearable
          :placeholder="$t('itemInfo.inputNumber')"
        />
      </van-cell-group>
      <!-- 入庫物品价格 -->
      <van-cell-group v-if="status == 1">
        <van-field
          v-model="itemInfo.price"
          :label="$t('itemInfo.price')"
          readonly
          :placeholder="$t('itemInfo.inputPrice')"
        />
      </van-cell-group>
      <!-- 入庫保质期 -->
      <van-cell-group v-if="status == 1">
        <van-cell
          :title="$t('itemInfo.qualityDate')"
          :value="itemInfo.qualityDate"
          is-link
          @click="showLanguage = true"
        />
        <!-- 日期选择弹出 -->
        <van-popup
          v-model="showLanguage"
          position="bottom"
        >
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            :title="$t('itemInfo.qualityDate')"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showLanguage = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
      <!-- 出库 -->
      <van-cell-group v-if="status == 0">
        <van-cell
          :title="$t('itemInfo.exWarehouseReason')"
          :value="reason"
          is-link
          @click="showReason = true"
        />
        <!-- 出库原因弹框 -->
        <van-popup v-model="showReason" position="bottom">
          <van-picker
            show-toolbar
            :columns="reasonList"
            :confirm-button-text="$t('vantText.confirm')"
            :cancel-button-text="$t('vantText.cancel')"
            @cancel="showReason = false"
            @confirm="onReason"
          />
        </van-popup>
      </van-cell-group>
      <!-- 保存按钮 -->
      <van-button class="testBtn" round @click="submit(0)">
        {{ $t("PackageDish.save") }}
      </van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      minDate: "",
      maxDate: "",
      goodsId: "",
      status: "",
      currentDate:"",
      itemInfo: {
        name: "",
        number: "",
        price: "",
        qualityDate: "",
        date: "",
      },
      showLanguage: false,
      showdate: false,
      showReason: false,
      reasonList:[this.$t("itemInfo.exWarehouse"),this.$t("itemInfo.overdue"),this.$t("itemInfo.consume")],
      reason:'',
      act:''
    };
  },
  mounted() {
    this.goodsId = this.$route.query.id;
    this.status = this.$route.query.status;
    // 最小选择日期与最大选择日期
    this.minDate = new Date(Date.now())
    let date = Date.now() + 86400*1000 * 365 *10
    this.maxDate = new Date(date)  
    this.currentDate = this.nowDate()
    this.itemInfo.date = this.nowDate()
    this.getGoodInfo()
  },
  methods: {
    onReason(value,i){
      this.reason = value
      this.showReason = false
      this.act = i+1
    },
    // 當前日期
    nowDate(){
      return new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
    },
    // 获取当前物品资料
    getGoodInfo(){
      this.$axios({
      method: "get",
      headers: {
        Authorization: "Bearer " + sessionStorage.token,
      },
      // url: this.$build + `/api/goods/${this.goodsId}/show`,
      url: this.$build + `/api/menu/${this.goodsId}/index`,
    })
      .then((res) => {
        if (res.data.status == 200) {
          console.log(res.data.data);
          this.itemInfo.name = res.data.data.name;
          if (res.data.data.type = "o") {
            this.itemInfo.price = res.data.data.original_price
          }else if (res.data.data.type = "s") {
            this.itemInfo.price = res.data.data.special_price
          }
        } else {
          for (var item in res.data.error) {
            this.$toast({
              type: "fail",
              message: res.data.error[item],
            });
          }
        }
      })
      .catch((err) => {});
    },
    goback() {
      this.$router.go(-1); //返回上一层
    },
    //保質期選擇
    onConfirm(e) {
      console.log("保质期选择",this.timeFormat(e));
      this.itemInfo.qualityDate = this.timeFormat(e);
      this.showLanguage = false;
    },
    // 时间格式化 2019-09-08
    timeFormat(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      if (Number(month) < 10) {
        if (Number(day) < 10) {
          return year + "-0" + month + "-0" + day;
        } else {
          return year + "-0" + month + "-" + day;
        }
      } else {
        if (Number(day) < 10) {
          return year + "-" + month + "-0" + day;
        } else {
          return year + "-" + month + "-" + day;
        }
        // return year + "-" + month + "-" + day;
      }
    },
    // 提交
    submit() {
      // 入库
      if (this.status == 1) {
        var data = {
          number: this.itemInfo.number,
          price: this.itemInfo.price,
          life: this.itemInfo.qualityDate,
          date: this.itemInfo.date,
          status: this.status,
          menu_id: this.goodsId
        };
        console.log('-------',data);
      } else {
        // 出库
          var data = {
            menu_id: this.goodsId,
            number: this.itemInfo.number,
            status: this.status,
            act: this.act
          };
      }
      // 出入庫
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        data: data,
        url: this.$build + `/api/menu/inventory`,
      })
        .then((res) => {
          if (res.data.status == 200) {
            if (this.status == 1) {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.waSuccess"),
              });
            } else {
              this.$toast({
                type: "success",
                message: this.$t("itemInfo.exSuccess"),
              });
            }

            const vm = this;
            setTimeout(function () {
              vm.$router.go(-1);
            }, 1500);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
.shopList {
  /* padding-top: 20px; */
}
.testBtn {
  width: 50%;
  margin: 15px 25%;
  background: #2f75f4;
  color: #fff;
}
.widthon {
  width: 80%;
  margin: 20px 15px;
}
</style>


// WEBPACK FOOTER //
// src/Platform/UnitManage.vue